import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=4542e5ac&scoped=true&"
import script from "./Tier.vue?vue&type=script&lang=js&"
export * from "./Tier.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Tier.vue?vue&type=style&index=0&id=4542e5ac&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4542e5ac",
  null
  ,true
)

export default component.exports